import React from 'react'
import { useViewport } from '@chilecompra/react-kit/components'
import {
  REACT_APP_VIDEO_GENERAL,
  REACT_APP_VIDEO_COMPARATOR,
  REACT_APP_VIDEO_BUYERPROFILE,
  REACT_APP_VIDEO_PLATFORM
} from '../../config/settings/environment'
import AboutSiteNavButton from '../../components/Navigation/AboutSiteNavButton'
import { Description, GridContainer, GridItem, Root, Subtitle, Title, Video } from './AboutVideoTutorialsSection.styles'

/**
 * The AboutVideoTutorialsSection's container.
 */
const AboutVideoTutorialsSection = () => {
  const { size } = useViewport()

  return (
    <Root>
      <GridContainer padding="0 0 26px">
        <AboutSiteNavButton />
        <GridItem xs={10} sm={11}>
          <Title>Videotutoriales</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 26px">
        <GridItem xs={12}>
          <Description>
            En los siguientes videos encontrarás en detalle el uso que puedes darle al nuevo sitio de Datos Abiertos y a
            todas las herramientas que ChileCompra pone a tu disposición.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 32px" spacing={4}>
        <GridItem align={size.isUpToMedium ? 'left' : 'center'} md={6} xs={12}>
          <GridContainer padding="0 0 20px">
            <GridItem align="left" xs={12}>
              <Subtitle>Nuevo sitio</Subtitle>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <Video
                width="100%"
                src={REACT_APP_VIDEO_GENERAL}
                title="Datos Abiertos de ChileCompra"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem align={size.isUpToMedium ? 'left' : 'center'} md={6} xs={12}>
          <GridContainer padding="0 0 20px">
            <GridItem align="left" xs={12}>
              <Subtitle>Conoce la plataforma</Subtitle>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <Video
                width="100%"
                src={REACT_APP_VIDEO_PLATFORM}
                title="Conoce la nueva plataforma de datos abiertos de ChileCompra"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <GridContainer spacing={4}>
        <GridItem align={size.isUpToMedium ? 'left' : 'center'} md={6} xs={12}>
          <GridContainer padding="0 0 20px">
            <GridItem align="left" xs={12}>
              <Subtitle>Ficha de organismo comprador</Subtitle>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <Video
                width="100%"
                src={REACT_APP_VIDEO_BUYERPROFILE}
                title="Conoce la ficha de organismo comprador"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem align={size.isUpToMedium ? 'left' : 'center'} md={6} xs={12}>
          <GridContainer padding="0 0 20px">
            <GridItem align="left" xs={12}>
              <Subtitle>Comparador</Subtitle>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={12}>
              <Video
                width="100%"
                src={REACT_APP_VIDEO_COMPARATOR}
                title="Conoce el comparador de organismos publicos"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default AboutVideoTutorialsSection
